import { render, staticRenderFns } from "./DocumentwithName.vue?vue&type=template&id=a324ddd8&scoped=true"
import script from "./DocumentwithName.vue?vue&type=script&lang=js"
export * from "./DocumentwithName.vue?vue&type=script&lang=js"
import style0 from "./DocumentwithName.vue?vue&type=style&index=0&id=a324ddd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a324ddd8",
  null
  
)

export default component.exports